import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="text-xl font-heading font-bold text-background-50 cursor-pointer">
              学生的妈妈
            </Link>
            <p className="mt-3 text-sm text-background-300 leading-relaxed">
              陪伴孩子成长的智慧指南。帮助每一位学生的妈妈从焦虑走向从容。
            </p>
          </div>
          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
              内容分类
            </h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">
                  精选文章
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">
                  联系我们
                </a>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
              关注我们
            </h4>
            <p className="text-sm text-background-300 leading-relaxed mb-3">
              订阅我们的电子报，获取最新育儿资讯和实用技巧。
            </p>
            <div className="flex gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信公众号">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-700 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="小红书">
                <i className="ri-red-packet-line"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-400">
            &copy; {currentYear} 学生的妈妈. 保留所有权利.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-sm text-background-400 hover:text-background-200 transition-colors cursor-pointer">用户协议</a>
          </div>
        </div>
      </div>
    </footer>
  );
}